import React from "react";
import PropTypes from "prop-types";
import Constants from "rtr-constants";
import MembershipAcquisitionMessaging from "components/source/acquisition/membership-acquisition-messaging";
import Routes from "routes";

export default class RTRUpdateAcquisitionMessaging extends React.Component {
  static propTypes = {
    acquisitionMessaging: PropTypes.shape({
      cta: PropTypes.string,
      dek: PropTypes.string,
      hasSkuInBag: PropTypes.bool,
      list: PropTypes.arrayOf(PropTypes.string),
      primaryCtaAddsToBag: PropTypes.bool,
      primaryCtaUrl: PropTypes.string,
      promo: PropTypes.string,
      secondaryCta: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    loggingLocation: PropTypes.string.isRequired,
    product: PropTypes.object.isRequired,
  };

  static defaultProps = {
    acquisitionMessaging: {
      title: "Save with a Membership",
      dek: "Rent more items for less. Pause or cancel anytime.",
      list: [
        "Rent 4 items at a time",
        "No return dates",
        "Free shipping, rental coverage & dry cleaning",
        "Buy what you love at a members-only discount",
      ],
      cta: "Explore Memberships",
      secondaryCta: "Learn More",
    },
  };

  render() {
    const membershipType = Constants.analytics.membershipType.RTR_UPDATE; // This is used for pixels, and should be underscored as is analytics' preference
    const { acquisitionMessaging } = this.props;
    if (!acquisitionMessaging) {
      return;
    }

    const { title, dek, list, promo, cta, primaryCtaUrl, secondaryCta, primaryCtaAddsToBag } = acquisitionMessaging;
    const url = this.props.acquisitionMessaging.url || Routes.LP.update;
    const addToBagUrl = Routes.AddToBag.update;
    const hasSkuInBag = this.props.acquisitionMessaging?.hasSkuInBag ?? false;

    return (
      <MembershipAcquisitionMessaging
        product={this.props.product}
        membershipType={membershipType}
        loggingLocation={this.props.loggingLocation}
        title={title}
        dek={dek}
        list={list}
        promo={promo}
        cta={cta}
        primaryCtaUrl={primaryCtaUrl}
        secondaryCta={secondaryCta}
        url={url}
        addToBagUrl={addToBagUrl}
        hasSkuInBag={hasSkuInBag}
        primaryCtaAddsToBag={primaryCtaAddsToBag}
      />
    );
  }
}
